// Hilfetexte ("i"-Knopf) zu den Pruefpunkten – Teil 2
// Module: 04-TRAFO-SICHT, 05-OEL-WANNE, 05-SICHERHEITS-ZUBEHOER,
//         06-ERDERANLAGE, 07-ELEKTROTHERMOGRAFIE
//
// Geschrieben am 13.09.2026 als Entwurf. MUSS vom Buero fachlich
// gegengelesen werden, bevor die Texte als verbindlich gelten.
// Normangaben ohne Abschnittsnummern, ausser sie stammen aus der
// ETB-Vorlage selbst.
//
// Schluessel: `${modulCode}|${pos}` – pos genau wie in der Vorlage.
// Felder: was (was wird geprueft), achten (typische Maengel),
//         nio (wann n.i.O.), norm (Grundlage, kurz)

export const MODUL_INFO_TEIL2 = {
  '04-TRAFO-SICHT':
    'Sichtprüfung am Transformator: Schutzeinrichtungen, Erdungsmöglichkeiten, Absperrung mit Warnbalken und Schildern, Fahrrollen und MS-Kabel. Nur im freigeschalteten Zustand an den Trafo herantreten.',
  '05-OEL-WANNE':
    'Prüfung der Ölauffangwanne unter dem Öl-Trafo: Zustand, Dichtheit, Sauberkeit und ausreichendes Auffangvolumen. Entweder Blechwanne (05.1.x) oder Beschichtungssystem (05.2.x).',
  '05-SICHERHEITS-ZUBEHOER':
    'Prüfung, ob die in der Station nötige Schutzausrüstung, Hilfsmittel, Schilder und Pläne vorhanden, unbeschädigt und nicht abgelaufen sind. Prüfdaten und Herstellungsdaten ablesen.',
  '06-ERDERANLAGE':
    'Sichtprüfung der Potenzialausgleichschiene und der Erdungsverbindungen sowie Messung des Erdungswiderstands. Die Ohm-Werte werden im Erderanlage-Block erfasst.',
  '07-ELEKTROTHERMOGRAFIE':
    'Wärmebildaufnahme der Anlagenteile im Betrieb, um unzulässige Erwärmung an Verbindungen, Klemmen und Kabeln zu finden. Möglichst unter Last messen; ETB gibt keine festen Grenzwerte vor.',
};

export const INFO_TEIL2 = {
  // ── 04-TRAFO-SICHT ────────────────────────────────────────────
  '04-TRAFO-SICHT|04.1': {
    was: 'Ob alle Schutz- und Überwachungseinrichtungen am Trafo vorhanden sind und auslösen: z. B. Vollschutz, Buchholz, Thermometer, Kaltleiter, Auslösegeräte, Fallklappenrelais.',
    achten: [
      'Auslösung testen (Prüftaste / Kontakt) und Meldung bzw. Abschaltung am Schalter kontrollieren',
      'Schleppzeiger am Thermometer: Höchsttemperatur ablesen und notieren',
      'Vollschutz/Buchholz: Gas- oder Ölstandsanzeige, Dichtheit, lose Leitungen',
      'Beschädigte Anschlussleitungen, abgeklemmte oder überbrückte Kontakte',
    ],
    nio: 'n.i.O., wenn eine Schutzeinrichtung nicht auslöst, überbrückt ist, beschädigt ist oder keine Meldung weitergibt.',
    norm: 'DIN VDE 0105-100, Herstellerangaben Transformator',
  },
  '04-TRAFO-SICHT|04.2': {
    was: "Ob auf der Mittelspannungsseite (OS) des Trafos eine Möglichkeit zum Erden und Kurzschließen besteht, z. B. Kugelfestpunkte oder Erdungsanschlüsse. Entfällt, wenn der Trafo OS-seitig gesteckt ist (Außenkonus) – dann wird im Trafofeld geerdet.",
    achten: [
      "Festpunkte an allen drei Phasen und am Erdanschluss vorhanden",
      "Festpunkte fest, nicht korrodiert, nicht lackiert",
      "Mit der Erdungsgarnitur der Station tatsächlich erreichbar",
    ],
    nio: "n.i.O., wenn keine oder nur eine unvollständige Erdungsmöglichkeit vorhanden ist oder sie nicht nutzbar ist. Wird immer gebraucht: Bei Arbeiten am Trafo muss geerdet werden.",
    norm: "DIN VDE 0105-100, DIN EN 61230 (VDE 0683-100)",
  },
  '04-TRAFO-SICHT|04.3': {
    was: "Ob auf der Niederspannungsseite (US) des Trafos eine Möglichkeit zum Erden und Kurzschließen besteht, z. B. Erdungsbolzen (Kugelfestpunkte) an L1, L2, L3 und PEN.",
    achten: [
      "Erdungsbolzen an allen Leitern vorhanden",
      "Fest, sauber, nicht lackiert oder korrodiert",
      "Mit der vorhandenen NS-Erdungsgarnitur nutzbar",
      "Steht beim Trafo „ohne Erdungsbolzen\", setzt die App diesen Punkt automatisch auf n.i.O.",
    ],
    nio: "n.i.O., wenn keine oder nur eine unvollständige Erdungsmöglichkeit vorhanden ist oder sie nicht nutzbar ist. Wird immer gebraucht: Bei Arbeiten am Trafo muss geerdet werden.",
    norm: "DIN VDE 0105-100, DIN EN 61230 (VDE 0683-100)",
  },
  '04-TRAFO-SICHT|04.12': {
    was: 'Ob der Sternpunkt (N-Leiter) direkt am Transformator geerdet ist.',
    achten: [
      'Verbindung vom N-Anschluss des Trafos zur Erdung bzw. zum Erdungsleiter suchen',
      'ja = Mangel (rot), nein = in Ordnung (grün) – Vorgabe ETB',
    ],
    nio: 'n.i.O., wenn der Sternpunkt am Transformator geerdet ist.',
    norm: 'Vorgabe ETB',
  },
  '04-TRAFO-SICHT|04.4': {
    was: 'Ob vor dem Trafo ein Warnbalken (Absperrung) angebracht ist, der das unbeabsichtigte Betreten des Trafobereichs verhindert.',
    achten: [
      'Balken vorhanden und eingehängt, nicht abgestellt oder zweckentfremdet',
      'Halterungen fest, Balken nicht verbogen oder gebrochen',
      'Balken versperrt den Zugang tatsächlich (Höhe, Breite)',
    ],
    nio: 'n.i.O., wenn der Warnbalken fehlt, beschädigt ist oder den Zugang nicht wirksam absperrt.',
    norm: 'TAB des Netzbetreibers, VDN, UV-Vorschrift (laut ETB-Vorlage)',
  },
  '04-TRAFO-SICHT|04.5': {
    was: 'Ob der Trafowarnbalken mit schwarz-gelbem Warnband (Schraffur) gekennzeichnet ist.',
    achten: [
      'Warnband vorhanden und gut sichtbar',
      'Nicht verblasst, abgelöst oder verschmutzt',
    ],
    nio: 'n.i.O., wenn das Warnband fehlt, stark verblasst oder abgelöst ist.',
    norm: 'UV-Vorschrift (laut ETB-Vorlage)',
  },
  '04-TRAFO-SICHT|04.6': {
    was: 'Ob am Warnbalken das dreieckige gelb-schwarze Warn-Kombischild „Hochspannung – Lebensgefahr" mit Blitzsymbol angebracht ist.',
    achten: [
      'Schild vorhanden, gut lesbar, fest angebracht',
      'Richtiges Symbol (Warnung vor elektrischer Spannung, W012)',
      'Nicht ausgeblichen, zerkratzt oder verdeckt',
    ],
    nio: 'n.i.O., wenn das Schild fehlt, unleserlich ist oder nicht dem vorgeschriebenen Symbol entspricht.',
    norm: 'ASR A1.3, DIN EN ISO 7010 (W012)',
  },
  '04-TRAFO-SICHT|04.7': {
    was: "Nur bei Gießharz-Trafos (GH): Ob das Warnschild „Gehäuse führt Spannung! Zutritt nur im abgeschalteten Zustand\" am Trafo bzw. an der Absperrung angebracht ist. Beim Öl-Trafo erscheint die Frage nicht.",
    achten: [
      "Schild vorhanden, gut lesbar, fest angebracht",
      "Beim Zugang zum Trafo gut sichtbar",
    ],
    nio: "n.i.O., wenn das Schild fehlt, unleserlich oder beschädigt ist.",
    norm: "UV-Vorschrift (laut ETB-Vorlage)",
  },
  '04-TRAFO-SICHT|04.8': {
    was: "Ob der Trafo gegen Wegrollen gesichert ist: Rollensperren an den Fahrrollen ODER Schwingungsdämpfer, auf denen der Trafo steht.",
    achten: [
      "Rollensperren an allen Rollen angebracht und fest",
      "Schwingungsdämpfer statt Rollensperren: i.O. wählen und in der Bemerkung notieren",
      "Trafo lässt sich nicht verschieben, Sperren nicht verrutscht",
    ],
    nio: "n.i.O., wenn weder Rollensperren noch Schwingungsdämpfer vorhanden sind oder die Sicherung lose bzw. unwirksam ist.",
    norm: "DIN VDE 0105-100, Gefährdungsbeurteilung nach ArbSchG, DGUV Vorschrift 1",
  },
  '04-TRAFO-SICHT|04.9': {
    was: 'Ob die Schirme der MS-Kabel beidseitig geerdet sind, also sowohl am Trafo als auch am Schaltfeld der MS-Anlage.',
    achten: [
      'Schirmanschluss am Trafo-Endverschluss sichtbar mit Erde verbunden',
      'Schirmanschluss am Kabelende in der MS-Anlage ebenfalls geerdet',
      'Erdungsleitungen fest, nicht abgerissen oder korrodiert',
    ],
    nio: 'n.i.O., wenn der Kabelschirm nur einseitig oder gar nicht geerdet ist.',
    norm: 'Vorgabe ETB / Netzbetreiber (Normbezug durch Büro zu ergänzen)',
  },
  '04-TRAFO-SICHT|04.10': {
    was: "Nur bei Netzbetreiber Netze BW / EnBW: Ob über dem Trafo eine Erdungsschiene angebracht ist.",
    achten: [
      "Schiene oberhalb des Trafos vorhanden",
      "Bei „ja\" folgt die Frage nach dem Zustand (Isolierstützer, Befestigung)",
    ],
    nio: "„nein\" ist ein Mangel – Netze BW verlangt die Schiene.",
    norm: "Vorgabe Netze BW / EnBW",
  },
  '04-TRAFO-SICHT|04.11': {
    was: "Zustand der Erdungsschiene über dem Trafo.",
    achten: [
      "Isolierstützer vorhanden und unbeschädigt",
      "Schiene fest montiert, keine Korrosion",
    ],
    nio: "n.i.O., wenn Isolierstützer fehlen oder beschädigt sind, die Schiene lose ist oder korrodiert – Grund antippen.",
    norm: "Vorgabe Netze BW / EnBW",
  },

  // ── 05-OEL-WANNE ──────────────────────────────────────────────
  '05-OEL-WANNE|05.1': {
    was: 'Ob unter dem Öl-Trafo eine Ölauffangwanne vorhanden ist – entweder als Blechwanne oder als Beschichtungssystem (beschichtete Betonwanne).',
    achten: [
      'Bei Gießharz-Trafo (ohne Öl) wird keine Wanne gebraucht',
      'Wanne muss den ganzen Trafo erfassen, auch Tropfstellen am Rand',
      'Bei „nein" weiter mit Punkt 6',
    ],
    nio: '„nein" wählen, wenn unter einem Öl-Trafo weder Blechwanne noch Beschichtungssystem vorhanden ist.',
    norm: 'AwSV, TRwS 779, DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.1.1': {
    was: "Wie ist die Ölauffangwanne ausgeführt? Wanne aus Blech, Kunststoff oder sonstigem Material – oder Fertigstation mit Anstrich (Beschichtung).",
    achten: [
      "Wanne: danach die Fragen zur Wanne und oben die Maße abmessen (alles in Meter)",
      "Anstrich: kein Abmessen, das Auffangvolumen gilt als i.O.",
      "Sonstiges Material: bei „Zusatzangaben\" eintragen",
    ],
    nio: "Kein i.O./n.i.O. – nur die Ausführung wählen. Fehlt die Wanne ganz, ist 05.1 „nein\" der Mangel.",
    norm: "AwSV, TRwS 779",
  },
  '05-OEL-WANNE|05.1.2': {
    was: 'Sichtprüfung der Blechwanne auf Korrosion, Risse und Verformungen.',
    achten: [
      'Rost, vor allem Durchrostung am Boden und in Ecken',
      'Risse, Beulen oder Verformungen durch Trafogewicht oder Transport',
      'Abgeplatzter Korrosionsschutz',
    ],
    nio: 'n.i.O., wenn Korrosion, Risse oder Verformungen die Dichtheit oder Tragfähigkeit gefährden.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.3': {
    was: 'Kontrolle der Schweißnähte und Übergänge der Blechwanne auf Dichtheit.',
    achten: [
      'Risse oder Poren in Schweißnähten',
      'Ölspuren oder Feuchtigkeit außerhalb bzw. unter der Wanne',
      'Undichte Durchführungen oder Anschlüsse',
    ],
    nio: 'n.i.O., wenn eine Naht oder ein Übergang undicht ist oder Anzeichen von Undichtheit zeigt.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.4': {
    was: 'Ob in der Blechwanne Wasser, Öl oder Schmutz steht.',
    achten: [
      'Stehendes Wasser (Kondensat, undichtes Dach, Grundwasser)',
      'Ölreste als Hinweis auf eine Undichtheit am Trafo',
      'Laub, Schmutz, Tierreste',
    ],
    nio: 'n.i.O., wenn Wasser, Öl oder Schmutz in der Wanne steht.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.5': {
    was: 'Ob das Auffangvolumen der Blechwanne mindestens der Ölmenge des Trafos entspricht (Ölmenge laut Typenschild).',
    achten: [
      'Ölmenge vom Typenschild ablesen (kg oder Liter)',
      'Wannenvolumen aus den Maßen im Stationsformular (Ölwanne) vergleichen',
      'Bei mehreren Trafos auf gemeinsamer Wanne: Gesamtmenge beachten',
    ],
    nio: 'n.i.O., wenn das Auffangvolumen kleiner ist als die Ölmenge des Trafos.',
    norm: 'AwSV, TRwS 779, DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.1.6': {
    was: 'Ob das Auffangvolumen der Blechwanne durch Gegenstände verkleinert wird.',
    achten: [
      'Abgestellte Gegenstände, Material, Kabelreste in der Wanne',
      'Einbauten wie Unterbauten oder Steine, die Volumen wegnehmen',
    ],
    nio: 'n.i.O., wenn Fremdkörper in der Wanne liegen und das Auffangvolumen verringern.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.1.7': {
    was: 'Ob die Blechwanne an die Erdungsanlage angeschlossen ist.',
    achten: [
      'Erdungsleitung an der Wanne vorhanden und fest',
      'Anschlussstelle nicht korrodiert oder lackiert',
      'Verbindung zur Potenzialausgleichschiene nachvollziehbar',
    ],
    nio: 'n.i.O., wenn die Erdungsverbindung fehlt, lose oder stark korrodiert ist.',
    norm: 'DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.2.1': {
    was: 'Ob die Ölauffangwanne als Beschichtungssystem ausgeführt ist, z. B. eine öldicht beschichtete Betonwanne.',
    achten: [
      'Beschichtung am Boden und an den Wänden der Trafozelle erkennbar',
      'Bei Blechwanne einfach „nein" wählen',
    ],
    nio: '„nein" ist kein Mangel – dann ist die Wanne als Blechwanne ausgeführt. Gibt es weder Blechwanne noch Beschichtung, ist 05.1 „nein" der Mangel.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.2': {
    was: 'Sichtprüfung der Beschichtung auf Risse, Abplatzungen und Blasen.',
    achten: [
      'Haarrisse oder Risse im Beton, die durch die Beschichtung gehen',
      'Abplatzungen, blanke Betonstellen',
      'Blasen oder Ablösungen (Hinweis auf Feuchtigkeit darunter)',
    ],
    nio: 'n.i.O., wenn Risse, Abplatzungen oder Blasen die Dichtheit der Beschichtung gefährden.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.3': {
    was: 'Kontrolle der Beschichtung auf mechanische Schäden und Abnutzung.',
    achten: [
      'Kratzer und Schlagstellen, z. B. vom Trafo-Einbau',
      'Abrieb an Stellen, wo Rollen oder Füße stehen',
      'Durchgescheuerte Beschichtung',
    ],
    nio: 'n.i.O., wenn mechanische Schäden oder Abnutzung die Beschichtung durchdringen oder schwächen.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.4': {
    was: 'Ob in der beschichteten Wanne Wasser, Öl oder Schmutz steht.',
    achten: [
      'Stehendes Wasser (Kondensat, undichtes Dach, Grundwasser)',
      'Ölreste als Hinweis auf eine Undichtheit am Trafo',
      'Laub, Schmutz, Tierreste',
    ],
    nio: 'n.i.O., wenn Wasser, Öl oder Schmutz in der Wanne steht.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.5': {
    was: 'Ob das Auffangvolumen der beschichteten Wanne mindestens der Ölmenge des Trafos entspricht (Ölmenge laut Typenschild).',
    achten: [
      'Ölmenge vom Typenschild ablesen (kg oder Liter)',
      'Volumen aus den Maßen im Stationsformular (Ölwanne) vergleichen',
      'Schwellen oder Aufkantungen an Türen gehören zur Wannenhöhe',
    ],
    nio: 'n.i.O., wenn das Auffangvolumen kleiner ist als die Ölmenge des Trafos.',
    norm: 'AwSV, TRwS 779, DIN EN 61936-1 (VDE 0101-1)',
  },
  '05-OEL-WANNE|05.2.6': {
    was: 'Ob das Auffangvolumen der beschichteten Wanne durch Gegenstände verkleinert wird.',
    achten: [
      'Abgestellte Gegenstände, Material, Kabelreste in der Wanne',
      'Nachträgliche Einbauten, die Volumen wegnehmen',
    ],
    nio: 'n.i.O., wenn Fremdkörper in der Wanne liegen und das Auffangvolumen verringern.',
    norm: 'AwSV, TRwS 779',
  },
  '05-OEL-WANNE|05.2.7': {
    was: 'Kontrolle der Beschichtung an den Übergängen zu Wänden, Ecken und Durchführungen.',
    achten: [
      'Ablösungen oder Risse in der Hohlkehle zwischen Boden und Wand',
      'Kabel- und Rohrdurchführungen dicht eingebunden',
      'Beschichtung reicht bis zur erforderlichen Höhe',
    ],
    nio: 'n.i.O., wenn die Beschichtung an Wandanschlüssen oder Durchführungen undicht, gerissen oder abgelöst ist.',
    norm: 'AwSV, TRwS 779',
  },

  // ── 05-SICHERHEITS-ZUBEHOER ───────────────────────────────────
  '05-SICHERHEITS-ZUBEHOER|05': {
    was: 'Ob ein NH-Sicherungs-Aufsteckgriff (mit Stulpe) zum Ziehen und Stecken von NH-Sicherungen in der Station vorhanden und in Ordnung ist.',
    achten: [
      'Griff vorhanden, Isolierung ohne Risse oder Brandspuren',
      'Verriegelung rastet sicher an der Sicherung ein',
      'Stulpe (Unterarmschutz) vorhanden und unbeschädigt',
    ],
    nio: 'n.i.O., wenn der Griff beschädigt ist, nicht sicher verriegelt oder die Stulpe fehlt.',
    norm: 'DIN VDE 0680 Teil 4',
  },
  '05-SICHERHEITS-ZUBEHOER|05.1': {
    was: 'Ob ein elektrisch isolierender Schutzhelm in der Station vorhanden und noch verwendbar ist.',
    achten: [
      'Kennzeichnung für elektrisch isolierende Helme (EN 50365) vorhanden',
      'Herstellungsdatum / Gebrauchsdauer laut Hersteller überschritten → „veraltet"',
      'Risse, Verfärbung, spröde Schale, defekte Innenausstattung',
    ],
    nio: 'n.i.O., wenn der Helm beschädigt ist, keine passende Kennzeichnung trägt oder die Gebrauchsdauer abgelaufen ist.',
    norm: 'DIN EN 50365',
  },
  '05-SICHERHEITS-ZUBEHOER|05.2': {
    was: 'Ob ein Gesichtsschutzschirm (Störlichtbogen-Schutz) für den Schutzhelm vorhanden und in Ordnung ist.',
    achten: [
      'Schirm passt auf den vorhandenen Helm',
      'Sichtscheibe klar, nicht zerkratzt oder gesprungen',
      'Kennzeichnung und Herstellungsdatum prüfen, abgelaufen → „veraltet"',
    ],
    nio: 'n.i.O., wenn der Schirm fehlt, beschädigt ist, nicht auf den Helm passt oder abgelaufen ist.',
    norm: 'DIN EN 166, GS-ET 29',
  },
  '05-SICHERHEITS-ZUBEHOER|05.3': {
    was: 'Ob eine Aufbewahrungstasche für die persönliche Schutzausrüstung (Helm, Schirm) vorhanden ist.',
    achten: [
      'Tasche vorhanden und sauber',
      'Schutzausrüstung ist tatsächlich darin verstaut (Schutz vor Staub, Licht)',
      'Tasche nicht zerrissen',
    ],
    nio: 'n.i.O., wenn die Tasche fehlt oder so beschädigt ist, dass sie die Ausrüstung nicht mehr schützt.',
    norm: 'Herstellerangaben der Schutzausrüstung',
  },
  '05-SICHERHEITS-ZUBEHOER|05.4': {
    was: 'Ob isolierende Schutzhandschuhe für Arbeiten bis 1000 V vorhanden, unbeschädigt und im Prüfzeitraum sind.',
    achten: [
      'Klasse und Kennzeichnung (Doppeldreieck) auf dem Handschuh',
      'Prüfdatum ablesen; überschrittenes Prüfdatum → „veraltet"',
      'Risse, Löcher, poröse oder klebrige Stellen (Aufblasprobe)',
    ],
    nio: 'n.i.O., wenn die Handschuhe beschädigt sind, die Kennzeichnung fehlt oder das Prüfdatum überschritten ist.',
    norm: 'DIN VDE 0682 Teil 311 (EN 60903)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.5': {
    was: 'Ob eine Aufbewahrungstasche für die isolierenden Handschuhe vorhanden ist.',
    achten: [
      'Tasche vorhanden, Handschuhe liegen darin',
      'Handschuhe nicht geknickt oder gequetscht gelagert',
      'Schutz vor Licht, Wärme und Schmutz gegeben',
    ],
    nio: 'n.i.O., wenn die Tasche fehlt oder die Handschuhe ungeschützt gelagert werden.',
    norm: 'DIN VDE 0682 Teil 311 (EN 60903)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.6': {
    was: 'Ob ein pneumatischer Handschuhprüfer vorhanden ist, mit dem die Handschuhe vor der Benutzung auf Dichtheit geprüft werden.',
    achten: [
      'Gerät vorhanden und funktionsfähig (hält den Druck)',
      'Passt zu den vorhandenen Handschuhen',
      'Keine Risse am Balg oder an der Klemmung',
    ],
    nio: 'n.i.O., wenn der Prüfer defekt ist, nicht passt oder die Luft nicht hält.',
    norm: 'DIN VDE 0682 Teil 311 (EN 60903)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.34': {
    was: "Ob eine isolierende Rettungsstange vorhanden ist, um eine verunfallte Person aus dem Gefahrenbereich zu ziehen (Rettung bei Elektrounfall).",
    achten: [
      "Stange vorhanden, sauber und trocken, Isolierteil ohne Risse",
      "Prüfplakette / letzte Prüfung (jährlich, Richtwert)",
      "Griffbegrenzung erkennbar",
    ],
    nio: "n.i.O., wenn die Rettungsstange fehlt, beschädigt ist oder die Prüffrist überschritten ist.",
    norm: "DIN EN IEC 61235 (VDE 0681-1); ETB-Broschüre 15",
  },
  '05-SICHERHEITS-ZUBEHOER|05.7': {
    was: 'Ob eine Isoliermatte (1 m × 1 m) aus Gummi zur Standortisolierung vor der NS-Anlage vorhanden und unbeschädigt ist.',
    achten: [
      'Matte vorhanden und liegt dort, wo bedient wird',
      'Keine Risse, Löcher, Brüche oder spröden Stellen',
      'Kennzeichnung (Spannungsklasse) lesbar',
    ],
    nio: 'n.i.O., wenn die Matte beschädigt, brüchig oder zu klein für den Bedienplatz ist.',
    norm: 'DIN VDE 0680 Teil 1',
  },
  '05-SICHERHEITS-ZUBEHOER|05.8': {
    was: 'Ob ein zweipoliger Spannungsprüfer für 230/400 V vorhanden und funktionsfähig ist.',
    achten: [
      'Eigentest bzw. Prüfung an bekannter Spannungsquelle vor Gebrauch',
      'Messspitzen mit Berührungsschutz, Leitung ohne Schäden',
      'Batterie in Ordnung, Anzeige lesbar',
    ],
    nio: 'n.i.O., wenn der Prüfer beschädigt ist, falsch anzeigt oder die Funktionsprobe nicht besteht.',
    norm: 'DIN VDE 0682-401 / EN 61243-3',
  },
  '05-SICHERHEITS-ZUBEHOER|05.9': {
    was: "Ob die vorgeschriebenen Warn- und Hinweisschilder vollständig, lesbar und fest angebracht sind.",
    achten: [
      "Je MS-/NS-Raum 4 Schilder: VDE-Hinweis, Erste Hilfe, Brandbekämpfung, 5 Sicherheitsregeln",
      "Ab 2 Ringkabelfeldern je Ringkabelfeld „Vorsicht Rückspannung\"",
      "Je MS-Feld „Nicht schalten\" und „Vorsicht geerdet und kurzgeschlossen\"",
      "Soll schlägt die App aus Räumen und MS-Feldern vor – Ist eintragen, dann bewertet sie selbst",
    ],
    nio: "n.i.O., wenn weniger Schilder vorhanden sind als nötig (Ist < Soll) oder Schilder unleserlich sind.",
    norm: "DIN VDE 0105-100, DIN EN ISO 7010, DGUV Vorschrift 1 und 3, DGUV Regel 103-011",
  },
  '05-SICHERHEITS-ZUBEHOER|05.10': {
    was: 'Ob eine Erdungsstange (isolierende Stange zum Ansetzen der Erdungs- und Kurzschließvorrichtung) vorhanden und in Ordnung ist.',
    achten: [
      'Isolierrohr ohne Risse, Kerben oder Verschmutzung',
      'Handhabebegrenzung (Handschutz) vorhanden',
      'Kopfstück passt zu den Erdungsklemmen der Station',
    ],
    nio: 'n.i.O., wenn die Stange beschädigt ist, nicht zur Garnitur passt oder überaltert ist.',
    norm: 'DIN EN 61235 (laut ETB-Vorlage)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.11': {
    was: 'Ob eine Erdungs- und Kurzschließvorrichtung (Erdungsgarnitur) passend für die Station vorhanden und unbeschädigt ist.',
    achten: [
      'Seile ohne Litzenbrüche, Schutzmantel unbeschädigt',
      'Klemmen fest verpresst, Gewinde gängig',
      'Querschnitt passt zum Kurzschlussstrom der Anlage (Typschild)',
    ],
    nio: 'n.i.O., wenn die Garnitur beschädigt ist, nicht zu den Festpunkten passt oder zu klein bemessen ist.',
    norm: 'DIN VDE 0683-100 (EN/IEC 61230)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.12': {
    was: 'Ob eine Wandhalterung für Erdungsgarnitur und Erdungsstange vorhanden ist.',
    achten: [
      'Halterung fest montiert',
      'Garnitur und Stange hängen geordnet und geschützt',
    ],
    nio: 'n.i.O., wenn die Halterung fehlt, lose ist oder die Geräte nicht aufnehmen kann.',
    norm: 'Herstellerangaben',
  },
  '05-SICHERHEITS-ZUBEHOER|05.13': {
    was: 'Ob eine HH-Sicherungszange zum Wechseln der Mittelspannungs-Sicherungen vorhanden und in Ordnung ist.',
    achten: [
      'Passt zu den eingebauten HH-Sicherungen',
      'Isolierteil ohne Risse, Mechanik gängig',
      'Sehr altes Modell oder Normstand überholt → „veraltet"',
    ],
    nio: 'n.i.O., wenn die Zange beschädigt ist, nicht passt oder nicht sicher greift.',
    norm: 'DIN VDE 0681-3',
  },
  '05-SICHERHEITS-ZUBEHOER|05.14': {
    was: 'Ob eine Halterung zur Aufbewahrung der HH-Sicherungen (z. B. Reservesicherungen) vorhanden ist.',
    achten: [
      'Halterung fest montiert',
      'Sicherungen liegen geschützt, nicht lose auf dem Boden',
    ],
    nio: 'n.i.O., wenn die Halterung fehlt oder beschädigt ist.',
    norm: 'Herstellerangaben',
  },
  '05-SICHERHEITS-ZUBEHOER|05.15': {
    was: 'Ob eine Halterung für die HH-Sicherungszange vorhanden ist.',
    achten: [
      'Halterung fest montiert',
      'Zange hängt geschützt und griffbereit',
    ],
    nio: 'n.i.O., wenn die Halterung fehlt oder beschädigt ist.',
    norm: 'Herstellerangaben',
  },
  '05-SICHERHEITS-ZUBEHOER|05.16': {
    was: 'Ob in der MS-Anlage die richtigen HH-Sicherungen eingesetzt sind. Bemessungsstrom und Bemessungsspannung notieren.',
    achten: [
      'Bemessungsstrom passt zur Trafoleistung (Auswahltabelle Hersteller)',
      'Bemessungsspannung passt zur Netzspannung',
      'Alle drei Phasen gleich bestückt, Schlagstift nicht ausgelöst',
    ],
    nio: 'n.i.O., wenn eine falsche Sicherungsgröße eingesetzt ist oder Sicherungen unterschiedlich bzw. beschädigt sind.',
    norm: 'DIN 43625',
  },
  '05-SICHERHEITS-ZUBEHOER|05.17': {
    was: 'Ob passende Reserve-HH-Sicherungen in der Station vorhanden sind. Bemessungsstrom und Bemessungsspannung notieren.',
    achten: [
      'Gleiche Werte wie die eingesetzten Betriebssicherungen',
      'Üblich ist ein kompletter Satz (drei Stück)',
      'Sicherungen unbeschädigt und trocken gelagert',
    ],
    nio: 'n.i.O., wenn Reservesicherungen fehlen, eine falsche Größe haben oder beschädigt sind.',
    norm: 'DIN 43625',
  },
  '05-SICHERHEITS-ZUBEHOER|05.18': {
    was: 'Ob ein Spannungsprüfer für Mittelspannung vorhanden, zur Netzspannung passend und funktionsfähig ist.',
    achten: [
      'Nennspannungsbereich passt zur Anlage',
      'Eigentest vorhanden und erfolgreich',
      'Isolierteil ohne Schäden; Prüfdatum / Wiederholungsprüfung beachten',
    ],
    nio: 'n.i.O., wenn der Prüfer nicht zur Spannung passt, beschädigt ist, den Eigentest nicht besteht oder überaltert ist.',
    norm: 'DIN VDE 0682 Teil 411 (EN/IEC 61243-1)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.19': {
    was: 'Ob Halterungen für die MS-Spannungsprüfer vorhanden sind. Soll- und Ist-Stückzahl eintragen.',
    achten: [
      'Anzahl Halterungen passt zur Anzahl Prüfer',
      'Halterungen fest montiert, Prüfer geschützt gelagert',
    ],
    nio: 'n.i.O., wenn Halterungen fehlen, lose sind oder zu wenige vorhanden sind.',
    norm: 'Herstellerangaben',
  },
  '05-SICHERHEITS-ZUBEHOER|05.20': {
    was: 'Ob eine Schalt- bzw. Isolierstange zum Bedienen der MS-Anlage vorhanden und unbeschädigt ist.',
    achten: [
      'Isolierrohr ohne Risse, Kerben, Verschmutzung',
      'Länge und Kopfstück passen zur Anlage',
      'Handhabebegrenzung vorhanden',
    ],
    nio: 'n.i.O., wenn die Stange beschädigt ist, nicht passt oder überaltert ist.',
    norm: 'E DIN VDE V 0681-1 und -2 (laut ETB-Vorlage)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.21': {
    was: 'Ob Halterungen für die Schaltstangen vorhanden sind. Soll- und Ist-Stückzahl eintragen.',
    achten: [
      'Anzahl Halterungen passt zur Anzahl Stangen',
      'Halterungen fest montiert, Stange hängt geschützt',
    ],
    nio: 'n.i.O., wenn Halterungen fehlen, lose sind oder zu wenige vorhanden sind.',
    norm: 'Herstellerangaben',
  },
  '05-SICHERHEITS-ZUBEHOER|05.22': {
    was: 'Ob auf der Oberspannungsseite (MS) des Trafos Kugelfestpunkte zum Anlegen der Erdungsgarnitur vorhanden sind.',
    achten: [
      'Festpunkte an allen drei Phasen vorhanden',
      'Fest angezogen, nicht korrodiert oder lackiert',
      'Bei gekapselten Steckern ggf. keine Festpunkte möglich → eigene Option',
    ],
    nio: 'n.i.O., wenn Kugelfestpunkte fehlen, beschädigt oder mit der Garnitur nicht nutzbar sind.',
    norm: 'DIN VDE 0683-100 (EN/IEC 61230), angelehnt an DIN 48088-1',
  },
  '05-SICHERHEITS-ZUBEHOER|05.23': {
    was: 'Ob auf der Unterspannungsseite (NS) des Trafos Kugelfestpunkte zum Anlegen der Erdungsgarnitur vorhanden sind.',
    achten: [
      'Festpunkte an L1, L2, L3 und PEN/N vorhanden',
      'Fest angezogen, nicht korrodiert oder lackiert',
      'Bei gekapselten Anschlüssen eigene Option wählen',
    ],
    nio: 'n.i.O., wenn Kugelfestpunkte fehlen, beschädigt oder mit der Garnitur nicht nutzbar sind.',
    norm: 'DIN VDE 0683-100 (EN/IEC 61230), angelehnt an DIN 48088-1',
  },
  '05-SICHERHEITS-ZUBEHOER|05.24': {
    was: 'Ob ein Spannungsanzeigegerät bzw. Prüfgerät für das kapazitive HR-System der MS-Anlage vorhanden und funktionsfähig ist.',
    achten: [
      'Gerät passt zum System der Anlage (HR, LRM usw.)',
      'Eigentest bzw. Schnittstellenprüfung erfolgreich',
      'Gehäuse und Stecker unbeschädigt',
    ],
    nio: 'n.i.O., wenn das Gerät fehlt, nicht zum System passt, defekt oder überaltert ist.',
    norm: 'DIN VDE 0682-415 (EN/IEC 61243-5)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.25': {
    was: "Ob ein aktueller Übersichtsschaltplan der MS-Anlage in der Station vorhanden ist.",
    achten: [
      "Plan vorhanden, lesbar und aktuell",
      "Ein kombinierter Schaltplan (MS und NS zusammen) ist ebenfalls in Ordnung → „i.O. – kombinierter Schaltplan\"",
    ],
    nio: "n.i.O., wenn kein Plan vorhanden oder er veraltet ist.",
    norm: "TAB des Netzbetreibers, VDN (laut ETB-Vorlage)",
  },
  '05-SICHERHEITS-ZUBEHOER|05.26': {
    was: "Ob ein aktueller Übersichtsschaltplan der NS-Anlage in der Station vorhanden ist.",
    achten: [
      "Plan vorhanden, lesbar und aktuell",
      "Ein kombinierter Schaltplan (MS und NS zusammen) ist ebenfalls in Ordnung → „i.O. – kombinierter Schaltplan\"",
    ],
    nio: "n.i.O., wenn kein Plan vorhanden oder er veraltet ist.",
    norm: "TAB des Netzbetreibers, VDN (laut ETB-Vorlage)",
  },
  '05-SICHERHEITS-ZUBEHOER|05.27': {
    was: 'Ob ein Akku-Handscheinwerfer für Arbeiten bei Stromausfall vorhanden und einsatzbereit ist.',
    achten: [
      'Einschalten und Leuchtkraft prüfen',
      'Akku geladen, Ladegerät angeschlossen (falls vorgesehen)',
      'Gehäuse unbeschädigt',
    ],
    nio: 'n.i.O., wenn der Scheinwerfer nicht leuchtet, der Akku leer bzw. defekt ist oder er beschädigt ist.',
    norm: 'TAB des Netzbetreibers, VDN, UV-Vorschrift (laut ETB-Vorlage)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.28': {
    was: 'Isoliermatte zum Auslegen in Schalt- und Prüfräumen. Hier nur Anzahl und Größe (Meter) erfassen.',
    achten: [
      'Anzahl der Matten zählen',
      'Länge und Breite in Metern notieren',
      'Brüchige oder beschädigte Matten zusätzlich vermerken',
    ],
    nio: 'n.i.O., wenn Matten fehlen, obwohl sie benötigt werden, oder sie brüchig bzw. beschädigt sind.',
    norm: 'DIN VDE 0303 Teil 2 (laut ETB-Vorlage)',
  },
  '05-SICHERHEITS-ZUBEHOER|05.29': {
    was: 'Ob isolierende Schutzplatten zum Abdecken benachbarter spannungsführender Teile vorhanden sind. Maße (H, B, Stärke) und Baujahr eintragen.',
    achten: [
      'Platten ohne Risse, Brüche, Brandspuren oder Verschmutzung',
      'Größe passt zur Anlage (Abdeckung der Nachbarfelder möglich)',
      'Baujahr und Kennzeichnung ablesen',
    ],
    nio: 'n.i.O., wenn die Platten beschädigt sind, nicht zur Anlage passen oder überaltert sind.',
    norm: 'DIN VDE 0682-552',
  },
  '05-SICHERHEITS-ZUBEHOER|05.30': {
    was: 'Ob ein CO2-Feuerlöscher in der Station vorhanden ist.',
    achten: [
      'Löscher vorhanden, griffbereit am Zugang aufgehängt',
      'Keine Beschädigung, Korrosion oder fehlende Plombe',
      'Halterung fest',
    ],
    nio: 'n.i.O., wenn der Feuerlöscher fehlt, beschädigt ist oder nicht griffbereit hängt.',
    norm: 'DIN EN 3 bzw. DIN 14406, DIN VDE 0105-100',
  },
  '05-SICHERHEITS-ZUBEHOER|05.31': {
    was: "Ob die Prüffrist des Feuerlöschers (alle 2 Jahre) eingehalten ist. Die App bewertet das selbst aus „Letzte Prüfung\" bei 05.30 – von Monat zu Monat gerechnet.",
    achten: [
      "Datum der letzten Prüfung bei 05.30 eintragen (Monat und Jahr genügen)",
      "Über 24 Monate → n.i.O.; die nächste Fälligkeit steht in der Bemerkung",
    ],
    nio: "n.i.O., wenn die letzte Prüfung mehr als 2 Jahre zurückliegt.",
    norm: "ASR A2.2, DIN 14406-4",
  },
  '05-SICHERHEITS-ZUBEHOER|05.32': {
    was: 'Ob alle Betriebsmittel (Schaltfelder, Trafos, Abgänge, Verteilungen) eindeutig und dauerhaft beschriftet sind.',
    achten: [
      'Beschriftung vorhanden, lesbar und dauerhaft',
      'Bezeichnungen stimmen mit dem Übersichtsschaltplan überein',
      'Auch Abgänge und Kabel in der NSHV beschriftet',
    ],
    nio: 'n.i.O., wenn Kennzeichnungen fehlen, unleserlich, unvollständig oder falsch sind.',
    norm: 'DIN VDE 0105-100',
  },
  '05-SICHERHEITS-ZUBEHOER|05.33': {
    was: 'Ob beim Bedienen der Anlage (Schalten, Sicherungen wechseln) keine spannungsführenden Teile berührt werden können.',
    achten: [
      'Abdeckungen und Berührungsschutz vollständig montiert',
      'Keine offenen Klemmen oder Schienen im Bedienbereich',
      'Fehlende Blindabdeckungen in Verteilungen',
    ],
    nio: 'n.i.O., wenn im Bedienbereich spannungsführende Teile ohne Berührungsschutz zugänglich sind.',
    norm: 'DGUV Vorschrift 3, DIN VDE 0106-100',
  },

  // ── 06-ERDERANLAGE ────────────────────────────────────────────
  '06-ERDERANLAGE|06': {
    was: 'Ob eine Haupt-Potenzialausgleichschiene vorhanden ist, an der Erder, PEN/PE und alle zu erdenden Teile zusammengeführt sind.',
    achten: [
      'Schiene vorhanden, fest montiert, nicht korrodiert',
      'Alle Klemmstellen fest angezogen',
      'Nicht mehr Leiter als Klemmen, keine Doppelbelegung → „überbelegt"',
    ],
    nio: 'n.i.O., wenn die Schiene fehlt, Anschlüsse lose oder korrodiert sind oder Klemmen mehrfach belegt sind.',
    norm: 'DIN VDE 0100 Teil 410 und Teil 540',
  },
  '06-ERDERANLAGE|06.1': {
    was: 'Ob die Anschlüsse an der Haupt-Potenzialausgleichschiene beschriftet sind (welcher Leiter geht wohin).',
    achten: [
      'Jeder Anschluss hat eine dauerhafte Beschriftung',
      'Beschriftung stimmt mit den tatsächlichen Leitern überein',
      'Erder deutlich erkennbar (wichtig für die Messung)',
    ],
    nio: 'n.i.O., wenn die Beschriftung fehlt, unleserlich, falsch oder unvollständig ist.',
    norm: 'DIN VDE 0100 Teil 540',
  },
  '06-ERDERANLAGE|06.2': {
    was: 'Ob alle metallischen Teile und Betriebsmittel der Station (Gehäuse, Trafo, Wanne, Türen, Gerüste, Kabelschirme) geerdet sind.',
    achten: [
      'Erdungsleitungen an Trafo, MS-Anlage, NSHV, Ölwanne, Türen',
      'Verbindungen fest, nicht korrodiert, nicht abgerissen',
      'Querschnitt nicht offensichtlich zu klein',
    ],
    nio: 'n.i.O., wenn ein Betriebsmittel nicht geerdet ist oder eine Erdungsverbindung lose, abgerissen oder stark korrodiert ist.',
    norm: 'DIN VDE 0100 Teil 200',
  },
  '06-ERDERANLAGE|06.4': {
    was: 'Ob jedes Betriebsmittel seinen eigenen Erdungsleiter direkt zur Erdungs-/Potentialausgleichsschiene hat (sternförmig) – statt von Bauteil zu Bauteil durchgeschleift zu sein.',
    achten: [
      'Trafo, Ölwanne, MS-Anlage, NSHV, Gehäuse und Türen je mit eigener Leitung an der Schiene',
      'Typischer Fehler: Ölwanne am Trafo angeschlossen und nur der Trafo an der Schiene',
      'Wird ein durchgeschleiftes Bauteil abgeklemmt (z. B. Trafotausch), ist alles dahinter ungeerdet',
    ],
    nio: 'n.i.O., wenn ein Betriebsmittel nur über ein anderes Bauteil geerdet ist oder ein Erdungsleiter fehlt – Grund antippen.',
    norm: 'DIN EN 50522 (VDE 0101-2), DIN VDE 0100-540 (Schutz-/Erdungsleiter nicht durchschleifen)',
  },
  '06-ERDERANLAGE|06.3': {
    was: 'Messung des Widerstands der Erdungsverbindungen an der Schiene. Die Werte werden im Erderanlage-Block eingetragen; ab > 2 Ω bewertet die App automatisch n.i.O.',
    achten: [
      'Grenzwert: Standard ≤ 2,0 Ω – steht bei der Station ein anderer Wert (z. B. Hamburg 1 Ω), gilt dieser',
      '„OL" am Messgerät = über dem Messbereich = keine leitende Verbindung = Mangel',
      'Messleitungen vorher kurzschließen und abgleichen',
      'Werte mit Komma eingeben, z. B. 0,35',
    ],
    nio: 'n.i.O., wenn ein Messwert über dem Grenzwert liegt (Standard 2,0 Ω) oder das Messgerät „OL" anzeigt.',
    norm: 'Grenzwert laut ETB-Vorlage (≤ 2,0 Ω), je Station änderbar',
  },

  // ── 07-ELEKTROTHERMOGRAFIE ────────────────────────────────────
  '07-ELEKTROTHERMOGRAFIE|07': {
    was: 'Wärmebildaufnahme der Niederspannungshauptverteilung im Betrieb: Sammelschienen, Sicherungen, Schalter und Klemmstellen.',
    achten: [
      'Einzelne Phasen oder Klemmen deutlich wärmer als vergleichbare Stellen',
      'Heiße NH-Sicherungen oder Sicherungsleisten (Kontaktprobleme)',
      'Möglichst unter Last messen; Last und Umgebungstemperatur notieren',
    ],
    nio: 'n.i.O., wenn eine auffällige Erwärmung festgestellt wird, die eine Nachprüfung oder Instandsetzung erfordert.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.1': {
    was: 'Wärmebildaufnahme der Mittelspannungsschaltanlage im Betrieb, soweit von außen einsehbar (Kabelanschlussraum, Sichtfenster).',
    achten: [
      'Warme Stellen an Kabelanschlüssen oder Sicherungsbereich',
      'Phasenvergleich: eine Phase wärmer als die anderen',
      'Keine Abdeckungen unter Spannung öffnen – nur messen, was zugänglich ist',
    ],
    nio: 'n.i.O., wenn eine auffällige Erwärmung festgestellt wird, die eine Nachprüfung oder Instandsetzung erfordert.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.2': {
    was: 'Wärmebildaufnahme des Transformators im Betrieb: Anschlüsse OS/US, Kessel bzw. Wicklungen, Kühlrippen.',
    achten: [
      'Warme Anschlussbolzen oder Klemmen an OS- oder US-Seite',
      'Ungleichmäßige Erwärmung am Kessel oder an den Kühlrippen',
      'Nur von außerhalb der Absperrung messen',
    ],
    nio: 'n.i.O., wenn eine auffällige Erwärmung festgestellt wird, die eine Nachprüfung oder Instandsetzung erfordert.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.3': {
    was: 'Wärmebildaufnahme der Niederspannungskabel und ihrer Anschlüsse, z. B. Trafo–NSHV-Verbindung und Abgänge.',
    achten: [
      'Warme Kabelschuhe oder Klemmstellen',
      'Einzelne Parallelkabel deutlich wärmer (ungleiche Stromaufteilung)',
      'Kabel in Bündeln oder an engen Stellen stark erwärmt',
    ],
    nio: 'n.i.O., wenn eine auffällige Erwärmung festgestellt wird, die eine Nachprüfung oder Instandsetzung erfordert.',
    norm: 'DIN 54191',
  },
  '07-ELEKTROTHERMOGRAFIE|07.4': {
    was: 'Wärmebildaufnahme der Mittelspannungskabel samt Endverschlüssen bzw. Steckern, soweit sichtbar.',
    achten: [
      'Warme Endverschlüsse oder Kabelstecker',
      'Phasenvergleich zwischen den drei Kabeln',
      'Warme Schirmanschlüsse',
    ],
    nio: 'n.i.O., wenn eine auffällige Erwärmung festgestellt wird, die eine Nachprüfung oder Instandsetzung erfordert.',
    norm: 'DIN 54191',
  },
};
